import templateUrl from 'emun.products/lists/product-list-email-prompt.htm'
import controller from 'emun.products/lists/product-list-email-prompt.controller'
import config from 'emun.products/lists/product-list-email-config'
import modals from 'webmodals/modals'

export default (options) => modals.open(Object.assign({
    size: options.size || 'md',
    backdrop: 'static',
    templateUrl: options.templateUrl || templateUrl,
    controller,
    bindToController: true,
    controllerAs: '$ctrl',
    resolve: {
        options: () => Object.assign({}, config, options),
        modals: modals
    }
}, options.modal)).result;